import styled from 'styled-components';
import { colors, gradients } from '@/styles';

export const DownloadProgressIndicator = styled.div<{ $progress?: number }>`
  font-size: 13px;
  .progress-bar {
    width: 100%;
    border: 1px solid ${colors.secondary.lightGray3};
    height: 30px;
    background-color: ${colors.secondary.lightGray1};

    position: relative;
    display: flex;

    border-radius: 500px;
    overflow: hidden;

    .progress {
      display: none;
      height: 100%;
      background-color: ${colors.semantic.information.light};
    }

    .back {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 500px;
      position: absolute;
      left: 5px;
      right: 5px;
      top: 5px;
      bottom: 5px;
      background: linear-gradient(90deg, ${gradients.brand.join(',')});
      color: white;
      clip-path: inset(0 ${(props) => 100 - (props.$progress || 0)}% 0 0 round 100px);
    }

    .front {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      color: black;

      clip-path: inset(0 0 0 ${(props) => props.$progress}% round 20px);
      transition: clip-path 1s linear;
    }
  }
`;
